'use strict';

var bonusProductsView = require('./bonus-products-view');
var Inputmask = require('inputmask');
var opcStore = require('@osfonepagecheckout/src/store').default;
var areEventListenersAttached = false;

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    cache: {
        $el: null,
        $content: null
    },
    refreshCache() {
        if (this.cache.$el) {
            this.cache.$content = this.cache.$el.querySelector('.mini-cart-content');
        }
    },
    init() {
        this.cache.$body = document.querySelector('body');
        this.cache.$el = document.querySelector('.header__minicart');

        this.refreshCache();
        if (this.cache.$el) {
            this.attachInitialEventListeners();
        }
    },
    // attach event listeners on initial page load
    attachInitialEventListeners() {
        var mouseEnterEventHandler = () => this.slide(true);
        var mouseleaveEventHandler = () => this.slide(false);

        // should be attached only once as element is not replaced
        window.addEventListener('minicartchanged', () => this.refresh(), false);
        window.mqR.add(() => {
            var currentBreakpoint = window.mqR.getBreakpoint();
            var showMinicart = ['desktop', 'desktopLarge'].indexOf(currentBreakpoint) !== -1;

            if (showMinicart && !areEventListenersAttached) {
                this.cache.$el.addEventListener('mouseenter', mouseEnterEventHandler);
                this.cache.$el.addEventListener('mouseleave', mouseleaveEventHandler);
                areEventListenersAttached = true;
            }
            if (!showMinicart && areEventListenersAttached) {
                this.cache.$el.removeEventListener('mouseenter', mouseEnterEventHandler);
                this.cache.$el.removeEventListener('mouseleave', mouseleaveEventHandler);
                areEventListenersAttached = false;
            }
        });

        this.refreshEventListeners();
    },
    // attach event listeners to elements that were replaced when minicart layout was updated
    refreshEventListeners() {
        if (this.cache.$content) {
            var miniCartClose = this.cache.$el.querySelector('.c-mini-cart__close');

            if (miniCartClose) {
                miniCartClose.addEventListener('click', event => {
                    this.close(event);
                });
            }

            this.initRemoveButtons();
            this.initQuantityInputs();
        }
    },
    initQuantityInputs() {
        var quantityInputs = document.querySelectorAll('.js_minicart_quantity'),
            minicartObj = this,
            increaseDecreaseEvent = function (event, valueToAdd) {
                var clickedElement = event.target || event.srcElement,
                    qtyInputElement = clickedElement.parentNode.querySelector('.js_minicart_quantity'),
                    previousQty = qtyInputElement.value,
                    newQty = parseInt(previousQty, 10) + valueToAdd;

                qtyInputElement.value = String(newQty);
                var qtyChangeEvent = document.createEvent('CustomEvent');
                qtyChangeEvent.initCustomEvent('change', false, false, null);
                qtyInputElement.dispatchEvent(qtyChangeEvent);
                minicartObj.checkInputValue(qtyInputElement);
            },
            changeEvent = function (event) {
                var targetElement = event.target || event.srcElement,
                    maxValue = Math.min(999, Number(targetElement.getAttribute('data-available'))),
                    minValue = 1,
                    currentValue = Number(targetElement.value);

                if (currentValue < minValue) {
                    targetElement.value = minValue;
                }

                if (currentValue > maxValue) {
                    targetElement.value = maxValue;
                }

                var updateRequest = new XMLHttpRequest(),
                    params        = JSON.stringify({pid: targetElement.getAttribute('data-item'), qty: targetElement.value}),
                    requestUrl    = (Urls && Urls.updateCartItemQuantity ? Urls.updateCartItemQuantity : document.getElementById('opcResources').getAttribute('minicart-update'));

                updateRequest.open('POST', requestUrl, true);
                updateRequest.onload = function () {
                    if (updateRequest.status >= 200 && updateRequest.status < 400) {
                        minicartObj.updateAndShow();
                    }
                };

                updateRequest.send(params);
            };

        if (quantityInputs != null) {
            for (var i = 0; i < quantityInputs.length; i++) {
                var qtyInput = quantityInputs[i],
                    quantityDecrease = qtyInput.parentNode.querySelector('.js_minicart_decrease'),
                    quantityIncrease = qtyInput.parentNode.querySelector('.js_minicart_increase');

                qtyInput.addEventListener('change', changeEvent);
                minicartObj.checkInputValue(qtyInput);

                quantityIncrease.addEventListener('click', function (event) {
                    increaseDecreaseEvent(event, 1);
                });

                quantityDecrease.addEventListener('click', function (event) {
                    increaseDecreaseEvent(event, -1);
                });

                var imDigitsWholeNumber = new Inputmask('999', { placeholder: '' });
                imDigitsWholeNumber.mask(qtyInput);
            }
        }
    },
    checkInputValue(element) {
        var maxValue = Math.min(999, Number(element.getAttribute('data-available'))),
            minValue = 1,
            quantityDecrease = element.parentNode.querySelector('.js_minicart_decrease'),
            quantityIncrease = element.parentNode.querySelector('.js_minicart_increase');

        if (parseInt(element.value, 10) <= minValue || !element.value || !element.value.match(/^\d+$/)) {
            element.value = minValue;
            quantityDecrease.classList.add('c-product__quantity--disabled');
        } else {
            quantityDecrease.classList.remove('c-product__quantity--disabled');
        }

        if (parseInt(element.value, 10) >= maxValue) {
            element.value = maxValue;
            quantityIncrease.classList.add('c-product__quantity--disabled');
        } else {
            quantityIncrease.classList.remove('c-product__quantity--disabled');
        }
    },
    initRemoveButtons() {
        var removeButtons = document.querySelectorAll('.js_minicart_remove'),
            minicartObj = this;

        if (removeButtons != null) {
            for (var i = 0; i < removeButtons.length; i++) {
                var removeBtn = removeButtons[i];
                removeBtn.addEventListener('click', function (event) {
                    var removeRequest = new XMLHttpRequest(),
                        targetElement = event.target || event.srcElement,
                        params = JSON.stringify({item: targetElement.getAttribute('data-item'), type: targetElement.getAttribute('data-type')}),
                        requestUrl = (Urls && Urls.removeCartItem ? Urls.removeCartItem : document.getElementById('opcResources').getAttribute('minicart-remove'));

                    removeRequest.open('POST', requestUrl, true);
                    removeRequest.onload = function () {
                        if (removeRequest.status >= 200 && removeRequest.status < 400) {
                            minicartObj.updateAndShow();
                        }
                    };

                    removeRequest.send(params);
                });
            }
        }
    },
    updateAndShow() {
        var refreshRequest = new XMLHttpRequest(),
            minicartObj = this,
            isOnePageCheckout = document.querySelector('body.checkout'),
            url = (isOnePageCheckout ? document.getElementById('opcResources').getAttribute('minicart-url') : Urls.loadMiniCart);

        refreshRequest.open('GET', url, true);
        refreshRequest.onload = function () {
            var requestFailed = !(refreshRequest.status >= 200 && refreshRequest.status < 400);

            if (requestFailed) {
                return;
            }

            var resp = refreshRequest.responseText,
                isDesktop = (window.mqR.getBreakpoint() === 'desktop' || window.mqR.getBreakpoint() === 'desktopLarge');

            minicartObj.show(resp, isDesktop, true);
            if (isOnePageCheckout) {
                // here comes the beauty of reactive storage - update the whole layout of cart page,
                // outside of Vue application itself, just by dispatching a single action
                opcStore.dispatch('getCart');
            }
        };

        refreshRequest.send();
    },
    refresh() {
        var request = new XMLHttpRequest();
        var miniCartUrl = document.getElementById('opcResources').getAttribute('minicart-url');

        request.open('GET', miniCartUrl, true);
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                var resp = request.responseText;

                this.cache.$el.innerHTML = resp;
                this.refreshCache();
                this.refreshEventListeners();
            }
        };

        request.send();
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     * @param {Boolean} If is a Desktop view
     * @param suppressTransition {Boolean} if opening transition animation should be suppressed to immediately
     * show the updated content of minicart overlay
     */
    show(html, isDesktop, suppressTransition = false) {
        // decrease minicart content flickering when changing cart content from minicart overlay
        if (suppressTransition && this.cache.$content) {
            this.cache.$content.classList.add('c-mini-cart__content--replacing');
        }

        this.cache.$el.innerHTML = html;
        if (isDesktop) {
            this.cache.$body.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
            this.refreshCache();
            if (suppressTransition && this.cache.$content) {
                this.cache.$content.classList.add('c-mini-cart__content--replacing');
            }
            this.refreshEventListeners();
            this.slide(true);
            // bonusProductsView.loadBonusOption();

            // wait until transition animation would end and remove suppressing class
            if (suppressTransition && this.cache.$content) {
                setTimeout(() => {
                    this.cache.$content.classList.remove('c-mini-cart__content--replacing');
                }, 750);
            }
        }
        // bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide(toShow) {
        var miniCartContent = document.querySelector('.c-mini-cart__content');

        // show the item
        if (toShow) {
            timer.clear();
            show();
        } else {
            // after a time out automatically close it
            timer.start(1500, hide);
        }

        if (miniCartContent) {
            miniCartContent.classList.add('c-mini-cart__content--expanded');
        }
    },
    /**
     * @function
     * @description Closes the mini cart
     */
    close(event, delay) {
        hide();
        document.querySelector('.c-mini-cart__content').classList.remove('c-mini-cart__content--expanded');
    }
};

// Show an element
var show = function () {
    // Get the natural height of the element
    var elem = document.querySelector('.c-mini-cart__content');
    if (elem) {
        var getHeight = function () {
            elem.style.display = 'block'; // Make it visible
            var height = elem.scrollHeight + 'px'; // Get it's height
            elem.style.display = ''; //  Hide it again
            return height;
        };

        if (!elem.classList.contains('is-visible')) {
            elem.style.maxHeight = getHeight(); // Update the max-height
            elem.classList.add('is-visible'); // Make the element visible
        }

        // Once the transition is complete, remove the inline max-height so the content can scale responsively
        window.setTimeout(function () {
            elem.style.maxHeight = '';
        }, 350);
    }
};

// Hide an element
var hide = function () {
    // Give the element a height to change from
    var elem = document.querySelector('.c-mini-cart__content');

    if (!elem) {
        return;
    }
    console.log('elem.scrollHeight', elem.scrollHeight);
    elem.style.maxHeight = elem.scrollHeight + 'px';

    // Set the height back to 0
    window.setTimeout(function () {
        elem.style.maxHeight = '0';
    }, 1);

    // When the transition is complete, hide it
    window.setTimeout(function () {
        elem.classList.remove('is-visible');
    }, 350);
};

module.exports = minicart;
